import React from "react";
import PageTitle from "../../layout/PageTitle";
import {Container} from "react-bootstrap";
import {Link} from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <Container>
      <PageTitle title='Politica de Confidențialitate' />

      <h5>Colectarea și utilizarea informațiilor</h5>
      <ul>
        <li>
          Colectăm informații personale doar atunci când acestea ne sunt furnizate voluntar de către utilizatori, de
          exemplu, atunci când completați formulare de contact sau efectuați o achiziție pe website-ul nostru.
        </li>
        <li>
          Informațiile colectate pot include nume, adresă de e-mail, adresă poștală, număr de telefon și alte detalii
          necesare pentru a vă furniza serviciile solicitate.
        </li>
        <li>
          Utilizăm informațiile colectate pentru a vă oferi serviciile solicitate, pentru a vă trimite actualizări și
          notificări relevante și pentru a răspunde la întrebările sau solicitările dvs.
        </li>
      </ul>


      <h5>Confidențialitatea datelor</h5>
      <ul>
        <li>
          Ne angajăm să protejăm confidențialitatea datelor dvs. personale și să nu le dezvăluim către terți fără
          consimțământul dvs., cu excepția cazurilor prevăzute de lege sau în cazurile în care este necesar pentru
          furnizarea serviciilor solicitate de dvs.
        </li>
        <li>
          Folosim măsuri de securitate adecvate pentru a proteja informațiile dvs. personale împotriva accesului
          neautorizat, utilizării sau divulgării.
        </li>
      </ul>

      <h5>Cookie-uri și tehnologii similare</h5>
      <ul>
        <li>
          Folosim cookie-uri și alte tehnologii de urmărire pentru a îmbunătăți experiența dvs. pe website-ul nostru și
          pentru a colecta informații despre utilizarea acestuia.
        </li>
        <li>
          Puteți gestiona preferințele cookie-urilor în setările browserului dvs. și puteți refuza utilizarea
          cookie-urilor
          prin setările corespunzătoare.
        </li>
      </ul>

      <h5>Link-uri către alte website-uri</h5>
      <ul>
        <li>
          Website-ul nostru poate conține link-uri către alte website-uri care nu sunt deținute sau controlate de noi.
          Nu ne asumăm nicio răspundere pentru practicile de confidențialitate sau conținutul acestor website-uri.
        </li>
      </ul>

      <h5>Modificări ale politicii de confidențialitate</h5>
      <ul>
        <li>
          Ne rezervăm dreptul de a modifica această politică de confidențialitate în orice moment. Orice modificări vor
          fi publicate pe această pagină și vor intra în vigoare imediat după publicare.
        </li>
      </ul>

      <h5>Contact</h5>
      <ul>
        <li>
          Dacă aveți întrebări sau preocupări legate de această politică de confidențialitate sau de practicile noastre
          referitoare la date, vă rugăm să ne contactați la adresa <Link
          to="mailto:radrasoftcard@gmail.com">radrasoftcard@gmail.com</Link> sau prin formulatul de <Link
          to="/contact">contact</Link>.
        </li>
      </ul>
      <p>
        Prin utilizarea website-ului nostru, sunteți de acord cu colectarea și utilizarea informațiilor dvs. personale
        în
        conformitate cu această politică de confidențialitate.
      </p>

      <p className="text-decoration-underline fst-italic">Data ultimei actualizări: 20 Feb 2024</p>
    </Container>
  )
};

export default PrivacyPolicy;
